import React from "react";
import CollapseButton from "./CollapseButton";
import NameInput from "./NameInput";
import "./TopControls.css";

const TopControls = ({ designName, toggleTools, toolsVisible }) => {
  return (
    <div className="canvas-controls canvas-controls--top">
      <CollapseButton toggleTools={toggleTools} toolsVisible={toolsVisible} />
      <NameInput designName={designName} />
    </div>
  );
};

export default TopControls;
